import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial";
import { RootState } from "../../index";
import {
  getBookings,
  searchFlight,
  searchOneFlight,
} from "../../service/flight";

export const flightSlice = createSlice({
  name: "flight",
  initialState,
  reducers: {
    setUpdateActive: (state, { payload }: PayloadAction<{}>) => {
      // state.active = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchFlight.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload.data;
      })
      .addCase(searchFlight.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchFlight.rejected, (state) => {
        state.loading = false;
      })
      .addCase(searchOneFlight.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.flight = payload.data;
      })
      .addCase(searchOneFlight.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchOneFlight.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getBookings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.bookings = payload.data?.bookings;
      })
      .addCase(getBookings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBookings.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default flightSlice.reducer;
export const SelectFlight = (state: RootState) => state.flight;
